import useAPI from "../../../../hooks/useAPI";
import useDataTableControls from "../../../../hooks/useDataTableControls";

export const PROJECT_APPLICATIONS_FILTERS = {
  USER: 'user',
  PROJECT: 'project',
  STATUS: 'status',
  SORT: 'sort'
}

export const PROJECT_APPLICATIONS_STATUS = {
  UNDER_ANALYSIS: 1,
  APPROVED: 2,
  FINISHED: 3,
}

const buildProjectApplicationURL = ({ baseURL, filters, page = 1, rowsPerPage = 50 }) => {
  const query = {
    ...(filters?.[PROJECT_APPLICATIONS_FILTERS.USER] && filters?.[PROJECT_APPLICATIONS_FILTERS.USER] !== 'all' && {user: filters[PROJECT_APPLICATIONS_FILTERS.USER]}),
    ...(filters?.[PROJECT_APPLICATIONS_FILTERS.PROJECT] && filters?.[PROJECT_APPLICATIONS_FILTERS.PROJECT] !== 'all' && {project: filters[PROJECT_APPLICATIONS_FILTERS.PROJECT]}),
    ...(filters?.[PROJECT_APPLICATIONS_FILTERS.STATUS] && filters?.[PROJECT_APPLICATIONS_FILTERS.STATUS] !== 'all' && {status: filters[PROJECT_APPLICATIONS_FILTERS.STATUS]}),
    ...(filters?.[PROJECT_APPLICATIONS_FILTERS.SORT] && {sort: filters[PROJECT_APPLICATIONS_FILTERS.SORT]}),
    page,
    limit: rowsPerPage
  }

  const urlSearchParams = new URLSearchParams(query);

  const urlQuery = urlSearchParams.size > 0 ? `?${urlSearchParams.toString()}` : '';

  return `${baseURL}${urlQuery}`;
}

export default function useProjectApplications() {
  const dataTableControls = useDataTableControls();
  const { data, isLoading, refreshData } = useAPI(buildProjectApplicationURL({ baseURL: '/admin/project-applications', filters: dataTableControls.filters, page: dataTableControls.page, rowsPerPage: dataTableControls.rowsPerPage }))
  
  return {
    data: data?.data,
    total: data?.paging?.total,
    isLoading,
    refreshData,
    ...dataTableControls
  }
}